import { TFCartBaseContent } from '~graphql/generated/clientGraphql'
import { getGroupItemsByHash } from '~logic/helpers/groupUtils/groupItems'

import { getOrderItemHash } from './getOrderItemHash'
import { sortOrderItems } from './sortOrderItems'

/**
 * Group items of each product with same addons, note, ...
 *
 * Sorts the items first.
 */
export const getGroupedOrderItems = (goods: TFCartBaseContent) => {
  const sortedItems = sortOrderItems(goods.items)

  return getGroupItemsByHash(getOrderItemHash)(sortedItems)
}
